(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-heading"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const descEl = document.querySelector('.collectionDesc');
    const btn = document.querySelector('.readMoreBtn');
    if (! descEl || ! btn || ! descEl.dataset.full) return;
    const fullHTML = descEl
      .dataset
      .full
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');
    const temp = document.createElement('div');
    temp.innerHTML = fullHTML;
    const plainText = temp.textContent || temp.innerText || '';
    const words = plainText.trim().split(/\s+/);
    const limit = 70;
    if (words.length > limit) {
      const visibleText = words.slice(0, limit).join(' ');
      const hiddenText = words.slice(limit).join(' ');
      descEl.innerHTML = `
        <span class="visible-text">${visibleText}</span>
        <span class="hidden-text"> ${hiddenText}</span>
      `;
      btn.classList.add('read-more-btn--visible');
      let expanded = false;
      btn.addEventListener('click', function() {
        if (! expanded) {
          descEl.classList.remove('collapsed');
          descEl.classList.add('is-expanded');
          btn.textContent = 'Read less';
          btn.setAttribute('aria-expanded', 'true');
        } else {
          descEl.classList.add('collapsed');
          descEl.classList.remove('is-expanded');
          btn.textContent = 'Read more';
          btn.setAttribute('aria-expanded', 'false');
        } expanded = ! expanded;
      });
    } else {
      descEl.innerHTML = fullHTML;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
